module.exports = __webpack_public_path__ + "static/bread-zoom-72cf879db3e706bbb95135674f31a4e5.jpg";